/* The name and the size share a line: stacked, they made every row 55px. */
.file {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: var(--ink);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The quick-peek body: a label and its value, a row each. */
.peekFacts {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
}

.peekFact {
  display: grid;
  grid-template-columns: 6rem 1fr;
  gap: 8px;
  align-items: center;
  font-size: var(--t-dense);
}

.peekFact dt {
  color: var(--muted);
}

.peekFact dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.meta {
  flex: 0 0 auto;
}

.meta,
.none {
  color: var(--muted);
  font-size: var(--t-min);
}

.status {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font-size: var(--t-min);
  font-weight: 600;
  white-space: nowrap;
}

.status[data-tone="warn"] {
  border-color: var(--warn-line);
  background: var(--warn-w);
  color: var(--warn);
}

.more {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid var(--line);
}

.button {
  height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.button:hover:not(:disabled) {
  background: var(--panel-2);
}

.link {
  color: var(--accent);
  font-weight: 600;
}
